export default __webpack_public_path__ + "static/media/eletric7.1097514a.jpeg";